import React, { Component } from "react";
import CartContext from "./CartContext";
import { Carousel, Button, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Showcase } from "./Showcase";
import { DemoLinks } from "./Home";
import { ECommerceFeatures, ECommercePricing } from "./Pricing";
import { DigitalMarketingPricing } from "./Pricing";

import {
  RetailPosModule,
  InventoryModule,
  PurchasesModule,
  OrdersManagementModule,
  DeliveryManagementModule,
  PackagingManagementModule,
  CrmModule,
  HrmModule,
  AccountingModule,
  ReportsModule,
  ErpRetail,
  LeadsManagementModule,
  CouponsManagementModule,
  ECommerceB2CModule,
  DemoButton,
} from "./CommonModules";

export class ECommerceB2CRetail extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      index: 0,
      stores: [
        {
          name: "grocery.png",
          title: "Grocery Store",
          url: "https://supermarket.elasticcart.com",
        },
        {
          name: "fashions.png",
          title: "Fashion Shop",
          url: "https://fashion.elasticcart.com",
        },
        {
          name: "fruitsandvegetables.png",
          title: "Fruits and Vegetables Shop",
          url: "https://fruitsandvegetables.elasticcart.com",
        },
        {
          name: "furniture.png",
          title: "Furniture Shop",
          url: "https://furniture.elasticcart.com",
        },
        {
          name: "jewellery.png",
          title: "Jewellery Shop",
          url: "https://jewellery.elasticcart.com",
        },
        {
          name: "electronics.png",
          title: "Electronics Shop",
          url: "https://electronics.elasticcart.com",
        },
        {
          name: "Mobile.png",
          title: "Mobile Shop",
          url: "https://mobileshop.elasticcart.com",
        },
        {
          name: "floral.png",
          title: "Floral Store",
          url: "https://floral.elasticcart.com",
        },
        {
          name: "bakery.png",
          title: "Bakery Shop",
          url: "https://bakery.elasticcart.com",
        },
        {
          name: "books.png",
          title: "Books Shop",
          url: "https://books.elasticcart.com",
        },
        {
          name: "pharma.png",
          title: "Pharmacy Shop",
          url: "https://pharma.elasticcart.com",
        },
        {
          name: "sarees.png",
          title: "Boutique and Sarees Shop",
          url: "https://sarees.elasticcart.com",
        },
        {
          name: "sports.png",
          title: "Sports Shop",
          url: "https://sports.elasticcart.com",
        },
        {
          name: "meatshop.png",
          title: "Meat Shop",
          url: "https://restaurant.elasticcart.com",
        },
        {
          name: "machinery.png",
          title: "Tools and Machinery Store",
          url: "https://machinery.elasticcart.com",
        },
        {
          name: "aquiarium.png",
          title: "Aquarium Shop",
          url: "https://aquiarium.elasticcart.com",
        },
      ],
    };
  }

  handleSelect = (selectedIndex) => {
    this.setState({ index: selectedIndex });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    if (this.context.EcSettings.length === 0) {
      return <></>;
    }
    return (
      <section className="container-fluid py-5 bg-white" id="posSection">
        <div className="container">
          <div className="row gx-5">
            <div className="col-12 border-start border-5 border-primary ps-3 mb-lg-1">
              <h6 className="text-primary text-uppercase mb-1">
                Product & Features
              </h6>

              <Row className="mb-4">
                <Col md={8}>
                  {" "}
                  <h5 className="display-6 text-dark mb-3">
                    Online Store for Retail / E-Commerce B2C{" "}
                  </h5>
                </Col>
                <Col className="text-end">
                  <Button
                    as={Link}
                    variant="warning"
                    to="/Checkout"
                    onClick={() => {
                      if (this.context.userData.loginStatus !== "active") {
                        this.context.ShowUserLoginNew(true);
                      }
                      this.context.SetSelectedProduct(
                        this.context.prods.find(
                          (f) =>
                            f.productType === this.context.ProductType.ECommerce
                        )
                      );
                    }}
                  >
                    Try Free / Buy
                  </Button>
                  <DemoButton></DemoButton>
                </Col>
              </Row>
            </div>
            <p className="text-muted lead">
              We provide a complete solution for your online store, from product
              management to payment processing. Our platform is easy to use and
              customizable to fit your needs. Whether you're a small or large
              business, we have the tools to help you succeed in the online
              marketplace. Our E-Commerce B2C platform is designed to help you
              reach your customers and grow your business. With features like
              product easy checkout, SMS based OTP authentication, and a
              user-friendly interface, you can create a seamless shopping
              experience for your customers. Our platform is built to scale with
              your business, so you can focus on what you do best - selling your
              products. Try it free today and see the difference! <br />
            </p>

            <div className="col-lg-12 mb-lg-5">
              <video
                controls
                height="400px"
                autoPlay
                muted
                loop
                width="100%"
                // className="rounded shadow"
                aria-label="POS software demo video"
              >
                <source
                  src={
                    this.context.GetEcSettingValueByName(
                      "StorageBlobImageUrl"
                    ) + "ECommerceRetailB2cVideo.mp4"
                  }
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>

            <div className="py-5 text-center">
              <h1> Modal Business Sites</h1>
              <Carousel
                fade
                activeIndex={this.state.index}
                onSelect={this.handleSelect}
              >
                {this.state.stores.map((store, idx) => (
                  <Carousel.Item key={idx} interval={3000}>
                    <div className="bg-white border CornersRoundedBig p-4 text-center ">
                      <h3 className="text-dark mb-3">{store.title}</h3>
                      <a
                        href={store.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={`https://ecprdstorage01.blob.core.windows.net/elasticcart/images/${store.name}`}
                          alt={store.title}
                          className="img-fluid rounded"
                          style={{ maxHeight: "350px", objectFit: "contain" }}
                        />
                      </a>
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>

            <Row className="mb-4">
              <Col>
                {" "}
                <h5 className="display-6 text-dark mb-3">Key Features</h5>
              </Col>
              <Col className="text-end">
                <Button
                  as={Link}
                  variant="warning"
                  to="/Checkout"
                  onClick={() => {
                    if (this.context.userData.loginStatus !== "active") {
                      this.context.ShowUserLoginNew(true);
                    }
                    this.context.SetSelectedProduct(
                      this.context.prods.find(
                        (f) =>
                          f.productType === this.context.ProductType.ECommerce
                      )
                    );
                  }}
                >
                  Try Free / Buy
                </Button>
              </Col>
            </Row>

            <Row className="gy-0">
              <Col xs={12} md={6}>
                <div className="bg-light px-3 rounded h-100">
                  <ul className="list-unstyled small text-muted">
                    <li>✔ Free SSL and Custom domain</li>
                    <li>✔ Premium & Custom Themes</li>
                    <li>✔ OTP Authentication (SMS/Email)</li>
                    <li>✔ Payment Gateway, COD, Manual UPI</li>
                    <li>✔ Product Variants, Multi-Image, Video</li>
                    <li>✔ Discounts, Wishlists, Smart Cart</li>
                    <li>✔ Customer visited products</li>
                  </ul>
                </div>
              </Col>
              <Col xs={12} md={6}>
                <div className="bg-light px-3 rounded h-100">
                  <ul className="list-unstyled small text-muted">
                    <li>✔ Product Bundles, Gift Cards</li>
                    <li>✔ Vlogs & Blogs Integration</li>
                    <li>✔ Marketing ads, SEO, and Social Media</li>
                    <li>✔ Notifications: Email, WhatsApp, Abandoned Cart</li>
                    <li>✔ Multi-Store, Multi-Vendor, Multi-Currency</li>
                    <li>✔ Multi-Language, Multi-Location</li>
                    <li>✔ Product Reviews, Ratings, and Comments</li>
                    <li>✔ Customer Groups, Memberships, and Subscriptions</li>
                    <li>✔ Analytics, Reports, Customer Dashboard</li>
                  </ul>
                </div>
              </Col>
            </Row>

            {/* ERP Modules Section */}
            <section className="container my-5">
              <h5 className="display-6 text-dark mb-4">
                Explore Integrated ERP Modules That Power Your Business
              </h5>
              <Row className="g-3">
                {[
                  ECommerceB2CModule,
                  InventoryModule,
                  PurchasesModule,
                  OrdersManagementModule,
                  PackagingManagementModule,
                  DeliveryManagementModule,
                  CrmModule,
                  LeadsManagementModule,
                  CouponsManagementModule,
                  HrmModule,
                  AccountingModule,
                  ReportsModule,
                ].map((Module, index) => (
                  <Col md={6} lg={6} key={index}>
                    <div className="bg-light p-3 rounded shadow-sm h-100 hover-shadow">
                      <Module />
                    </div>
                  </Col>
                ))}
              </Row>
            </section>
          </div>
        </div>
      </section>
    );
  }
}
